import { DeviceEnrollmentStatus } from "../../generated/graphql";

export const DEVICE_ENROLLMENT_STATUS_CHOICES = [
  { id: DeviceEnrollmentStatus.Active, name: "deviceStatus.ACTIVE" },
  { id: DeviceEnrollmentStatus.Inactive, name: "deviceStatus.INACTIVE" },
  { id: DeviceEnrollmentStatus.Unenrolled, name: "deviceEnrollment.unenroll.status" },
];
